import React, { useState } from 'react';
import clinicService from '../../../../../services/clinic.service';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
function NewReputation({ clinicid, checkReputationService }) {
    const [showForm, setShowForm] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const onSubmit = (data) => {
        setIsSubmitting(true);
        const newData = { ...data, clinicId: clinicid };

        clinicService
            .addReputationClinic(clinicid, newData)
            .then(() => {
                toast.success('Reputation Enhancement added successfully', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                checkReputationService();
                reset();
                setShowForm(false);
            })
            .catch(() => {
                toast.error('Error: Please check your URL and try again', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    if (!showForm) {
        return (
            <div className="notifications-panel">
                <div className="notifications-panel__header">
                    <i className="bi bi-star"></i>
                    Get Started
                </div>
                <div className="notifications-panel__body">
                    <div className="reputation-empty">
                        <i className="bi bi-star"></i>
                        Reputation Enhancement is not set up for this clinic yet.
                        <p className="text-muted small mt-2 mb-0">
                            Create a short code to start managing your online reputation.
                        </p>
                        <div className="mt-3">
                            <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => setShowForm(true)}>
                                <i className="bi bi-plus-circle me-1"></i>
                                Begin Setup
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="notifications-panel">
            <div className="notifications-panel__header justify-content-between">
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-star"></i>
                    Setup Reputation Enhancement
                </span>
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => {
                        setShowForm(false);
                        reset();
                    }}
                    disabled={isSubmitting}
                >
                    Cancel
                </button>
            </div>
            <div className="notifications-panel__body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                        <label htmlFor="shortCode" className="notifications-form-label">
                            Short Code <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            className={`form-control form-control-sm ${errors.shortCode ? 'is-invalid' : ''}`}
                            id="shortCode"
                            placeholder="Enter unique short code"
                            {...register('shortCode', {
                                required: 'Short code is required',
                                pattern: {
                                    value: /^[a-zA-Z0-9_-]+$/,
                                    message: 'Only letters, numbers, hyphens and underscores allowed',
                                },
                                minLength: {
                                    value: 3,
                                    message: 'Short code must be at least 3 characters',
                                },
                            })}
                        />
                        {errors.shortCode && <div className="invalid-feedback">{errors.shortCode.message}</div>}
                        <div className="notifications-form-hint">This short code will be used in your reputation URL.</div>
                    </div>

                    <div className="reputation-form-actions">
                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { setShowForm(false); reset(); }} disabled={isSubmitting}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-success btn-sm" disabled={isSubmitting}>
                            {isSubmitting ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                    Setting up…
                                </>
                            ) : (
                                <>
                                    <i className="bi bi-floppy me-1"></i>
                                    Save
                                </>
                            )}
                        </button>
                    </div>
                </form>

                <div className="notifications-alert-banner mt-3">
                    <i className="bi bi-info-circle"></i>
                    <span>
                        The short code is a unique identifier for your reputation URL. Choose something meaningful — once set, it cannot be changed easily.
                    </span>
                </div>
            </div>
        </div>
    );
}

export default NewReputation;
